import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function CardItem({ card }) {
  return (
    <div className="casino-result-cards-item">
      <img src={getCardImage(card)} alt="" />
    </div>
  );
}

/**
 * Reference result body for Poker 6 Players (poker6): player s cards [s-1, s+5] (+ trophy when
 * "1"+s is in win), Board Card = cards[12..16]; rdesc "player#pattern".
 */
export default function Poker6ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const winners = t1?.win ? String(t1.win).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5 poker6result">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards casino-open-result">
              {[1, 2, 3, 4, 5, 6].map((s) => (
                <div key={s} className="casino-open-result-item">
                  <h4>{s}</h4>{" "}
                  <div className="casino-result-cards">
                    <div className="casino-result-cards-item-container">
                      <CardItem card={cards[s - 1]} /> <CardItem card={cards[s + 5]} />{" "}
                      {winners.indexOf(`1${s}`) !== -1 && (
                        <div className="casino-result-cards-item">
                          <img src={WINNER_IMG} className="winner-icon" alt="" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>{" "}
          <div className="casino-result-content-diveder" />{" "}
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              <div className="d-inline-block">
                <h4>Board Card</h4>
                {[12, 13, 14, 15, 16].map((i) => (
                  <React.Fragment key={i}>
                    {" "}
                    <CardItem card={cards[i]} />
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length ? (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>
                Player <span className="float-right">:</span>
              </div>{" "}
              <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>
                Pattern<span className="float-right">:</span>
              </div>{" "}
              <div>{desc[1]}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
